import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import nextyn_logo from "../../../assests/images/NX19.png";
import {
  AiOutlineLogout,
  IoOpenOutline,
  SlArrowRight,
  RxHamburgerMenu,
} from "../../../Utils/Icons";
// import "./Sidebar.css";
import { Avatar } from "antd";
import ExpertDashboard from "../../components/ExpertDashboard";
import { Offcanvas } from "react-bootstrap";

function Sidebar() {
  const userData = JSON.parse(localStorage.getItem("expertData"));
  const [profilePopover, setProfilePopover] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const handleLogout = () => {
    localStorage.removeItem("expertData");
    localStorage.removeItem("isExpertAuth");
    localStorage.removeItem("lastExpertLoginTime");
    localStorage.removeItem("lastExpertActiveTime");
    // localStorage.clear()
  };

  const menuItems = () => {
    return (
      <ul className="list-unstyled mainMenuUL">
        <li>
          <Link to="/expert/dashboard" activeclassname="menu_active">
            <svg
              stroke="currentColor"
              fill="none"
              stroke-width="1.5"
              viewBox="0 0 24 24"
              aria-hidden="true"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
              ></path>
            </svg>
            <span className="menu-text"> Dashboard </span>{" "}
          </Link>

          <NavLink to="/expert/call-records" activeclassname="menu_active">
            {" "}
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M320.9 19.054c-39.32 0-71 31.68-71 71s31.68 71 71 71 71-31.68 71-71-31.68-71-71-71zm0 30c22.537 0 41 18.463 41 41s-18.463 41-41 41-41-18.463-41-41 18.463-41 41-41zM146.5 64.42a37.825 37.825 0 0 0-8.3.83c-29.027 6.162-49.944 25.765-62.878 51.578-12.934 25.812-18.633 57.932-19.178 91.888-1.09 67.913 18.283 143.263 49.238 190.287 10.45 15.873 24.974 24.52 41.96 28.866 6.516 1.665 13.427 2.814 20.827 3.713a57.1 57.1 0 0 1-.27-5.53c0-4.142.572-8.306 1.642-12.485-6.597-.813-12.504-1.8-17.738-3.14-14.19-3.63-23.288-9.02-31.387-21.323-27.905-42.392-47.307-115.925-46.277-180.1.515-32.087 6.1-61.815 17.275-84.115 11.175-22.3 27.19-37.078 50.522-42.03 6.646-1.412 10.758-.17 15.23 3.33 4.473 3.503 8.925 9.938 12.633 18.57 6.386 14.87 10.5 35.725 13.035 56.294h18.133c-2.558-22.05-6.74-45.028-14.63-63.396-4.43-10.315-10.045-19.352-18.073-25.64-6.02-4.714-13.61-7.504-21.764-7.6zm174.4 2.634c-12.81 0-23 10.19-23 23s10.19 23 23 23 23-10.19 23-23-10.19-23-23-23zm-23 108.977v137.75c.14 3.726 1.945 6.4 6.222 9.108 4.293 2.717 10.887 4.59 17.405 4.78 6.517.19 12.843-1.326 16.732-3.762 3.888-2.436 5.64-4.806 5.64-9.852V176.03a88.702 88.702 0 0 1-23 3.024c-7.95 0-15.66-1.055-23-3.023zm-127.315 3.024c1.274 18.84 3.492 61.976-.802 88.442-2.047 12.612-7.35 26.95-11.577 37.558h69.385c-4.224-10.61-9.528-24.946-11.575-37.558-4.295-26.466-2.076-69.603-.803-88.442h-44.627zm63.315 16v30h46v-30h-46zm-89 126v18h96v-18h-96zm138.736 5.96c-27.298 14.694-51.16 32.19-68.373 49.403-19.15 19.152-29.363 38.137-29.363 49.637 0 13.182 5.877 23.69 16.293 33.068 10.415 9.378 25.387 17.005 41.552 22.393 45.724 15.24 108.584 15.24 154.307 0 16.166-5.388 31.137-13.015 41.553-22.393 10.416-9.377 16.295-19.886 16.295-33.068 0-21-10.155-38.33-29.022-55.31-16.857-15.172-40.628-29.394-68.123-43.57a30.515 30.515 0 0 1-10.94 11.988c-.07.042-.14.08-.208.123 17.422 2.965 33.142 8.79 45.972 16.875 19.12 12.05 32.32 29.83 32.32 50.394 0 20.566-13.2 38.345-32.32 50.395-19.12 12.048-44.638 19.104-72.68 19.104-28.043 0-53.562-7.056-72.682-19.105-19.12-12.05-32.318-29.83-32.318-50.396 0-20.565 13.2-38.345 32.318-50.394 13.266-8.36 29.617-14.31 47.75-17.174a42.995 42.995 0 0 1-1.47-.89c-4.3-2.72-8.18-6.5-10.862-11.08zm37.264 28.04c-24.977 0-47.46 6.487-63.084 16.334-15.626 9.848-23.916 22.32-23.916 35.166 0 12.848 8.29 25.32 23.916 35.166 15.625 9.848 38.107 16.334 63.084 16.334 15.375 0 29.797-2.465 42.263-6.652-4.685-3.872-9.765-8.13-14.255-12.965-3.65-3.93-6.973-8.283-9.022-13.594-2.05-5.31-2.506-11.822-.262-17.904l16.887 6.23c-.707 1.917-.64 3.096.17 5.195.81 2.098 2.68 4.874 5.42 7.824 5.012 5.398 12.588 11.12 19.345 17.054.86-.5 1.714-1.005 2.537-1.524 15.625-9.847 23.918-22.318 23.918-35.166 0-12.847-8.293-25.318-23.918-35.166-15.626-9.847-38.105-16.334-63.082-16.334zm-8.584 11.076h16v18h-16v-18zm38.006 5.383h16v18h-16v-18zm-72.506 3.137h16v18h-16v-18zm-27.98 26.404h16v18h-16v-18zm125.876 0h16v18h-16v-18zm-97.943 19.512h16v18h-16v-18zm34.782 8.762h16v18h-16v-18z"></path>
            </svg>
            <span className="menu-text"> Call Records </span>{" "}
          </NavLink>

          <NavLink to="/expert/payment" activeclassname="menu_active">
            {" "}
            <svg
              stroke="currentColor"
              fill="none"
              stroke-width="2"
              viewBox="0 0 24 24"
              aria-hidden="true"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <span className="menu-text"> Payments </span>{" "}
          </NavLink>

          <NavLink to="/expert/compliance" activeclassname="menu_active">
            {" "}
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 1024 1024"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
              <path d="M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"></path>
            </svg>
            <span className="menu-text"> Compliance </span>{" "}
          </NavLink>
          <NavLink
            to="/expert/change-password"
            activeclassname="menu_active"
            className={"d-lg-none"}
          >
            {" "}
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="M336 112a80 80 0 00-160 0v96"
              ></path>
              <rect
                width="320"
                height="272"
                x="96"
                y="208"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                rx="48"
                ry="48"
              ></rect>
            </svg>
            <span className="menu-text"> Change Password </span>{" "}
          </NavLink>
          <NavLink
            to={"/expert-login"}
            onClick={handleLogout}
            activeclassname="menu_active"
            className={"d-lg-none"}
          >
            {" "}
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 1024 1024"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z"></path>
            </svg>
            <span className="menu-text"> Logout </span>{" "}
          </NavLink>
        </li>
      </ul>
    );
  };

  return (
    <>
      <ExpertDashboard />
      <div className="sidebar-menu d-none d-lg-block" id="navAccordion">
        <div className="inside0div">
          <div className="logo-admin mb-xl-3">
            <NavLink to="/expert/dashboard">
              <img src={nextyn_logo} alt="logo" />
            </NavLink>
          </div>

          <div className="main-menu d-none d-lg-block">
            {menuItems()}

            <div className="userProfileWrapper">
              <div className="user_Profiles">
                <div
                  className="d-flex align-items-center justify-content-between p-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => setProfilePopover(!profilePopover)}
                >
                  <div className="d-flex align-items-center">
                    <Avatar
                      style={{
                        backgroundColor: "#EFEFEF",
                        color: "#f33636",
                        height: "30px",
                        width: "30px",
                      }}
                      alt={userData?.data?.first_name}
                    >
                      {userData?.data?.first_name
                        ? userData?.data?.first_name?.charAt(0)?.toUpperCase() +
                        "" +
                        userData?.data?.last_name?.charAt(0)?.toUpperCase()
                        : userData?.data?.name?.charAt(0)?.toUpperCase()}
                    </Avatar>
                    <div className="profileSidebarDetails d-none d-lg-block">
                      <h5>
                        {userData?.data?.first_name
                          ? userData?.data?.first_name +
                          " " +
                          userData?.data?.last_name
                          : userData?.data?.name}
                      </h5>
                      <p>{userData?.data?.email}</p>
                    </div>
                  </div>
                  <div>
                    <SlArrowRight />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`profilePopover`}>
        <div className={`positibsw ${profilePopover && "active"}`}>
          <div className="d-flex align-items-center">
            <Avatar
              style={{
                backgroundColor: "#EFEFEF",
                color: "#f33636",
                height: "30px",
                width: "30px",
              }}
              alt={userData?.data?.first_name}
            >
              {userData?.data?.first_name
                ? userData?.data?.first_name?.charAt(0)?.toUpperCase() +
                "" +
                userData?.data?.last_name?.charAt(0)?.toUpperCase()
                : userData?.data?.name?.charAt(0)?.toUpperCase()}
            </Avatar>
            <div className="profileSidebarDetails">
              <h5>
                {userData?.data?.first_name
                  ? userData?.data?.first_name + " " + userData?.data?.last_name
                  : userData?.data?.name}
              </h5>
              <p>{userData?.data?.email}</p>
            </div>
          </div>
          <hr />
          <ul className="profileUl">
            <li>
              <NavLink
                to={"/expert/change-password"}
                className="d-flex align-items-center"
                onClick={() => setProfilePopover(false)}
              >
                <IoOpenOutline className="me-2 fs-5" /> Change Password
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/expert-login"}
                onClick={handleLogout}
                className="d-flex align-items-center"
              >
                <AiOutlineLogout className="me-2 fs-5" /> Logout
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className="mobileMenu d-lg-none">
        <div className="d-flex align-items-center justify-content-between">
          <NavLink to="/expert/dashboard">
            <img src={nextyn_logo} alt="logo" style={{ width: "150px" }} />
          </NavLink>
          <div className="mobileHamburger" onClick={handleShow}>
            <RxHamburgerMenu />
          </div>
        </div>
      </div>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement={"end"}
        backdrop={true}
        className="menuBarOffCanvas"
      >
        <Offcanvas.Header closeButton>
          <NavLink to="/expert/dashboard">
            <img src={nextyn_logo} alt="logo" style={{ width: "150px" }} />
          </NavLink>
        </Offcanvas.Header>
        <Offcanvas.Body className="mobileMenuBody">
          {menuItems()}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default Sidebar;
